<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="card-app-design min-height">
                <div class="container my-3 p-5"></div>

                <div class="continer mx-auto">
                    <h1 class="text-center my-3">Aliff Franchises</h1>
                    <div class="d-flex flex-column align-items-start">
                    <div class="row container mx-auto">
                        <div class="col-md-6">
                            <p class="container align-items-center mt-5 pt-5">Our journey began as a dream project in the previous decade, and today, we are proud to announce that Aliff has transformed the dreams of over 23,000 students into reality. We are now offering you the opportunity to be a part of this incredible journey by becoming an Aliff franchisee.</p>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex flex-column align-items-center ">
                                <img src="@/assets/imgs/offices/ill.svg" class="img-fluid mt-5 p-5" alt="Image 1" />
                            </div>
                        </div>
                    </div>
                    </div>
                </div>


               <!-- search -->
               <div class="container my-2" style="border-radius: 10px">
                    <div class="col-12 my-5">
                        <div class="input-group mt-5 mx-1">
                            <input v-model="search" type="text" class="form-control rounded-pill"
                                placeholder="Search for a location..." aria-label="Search for a location..."
                                aria-describedby="search-button" />
                        </div>
                        <div class="mx-auto container mt-3 d-flex justify-content-center">
                            <button :class="[getCountryButtonClass('India'), 'blue-outline-button']"
                                @click="onCountrySelect('India')" class="position-relative btn-dark">
                                <!-- <img src="@/assets/imgs/offices/ind.png" class="img-fluid with-border"
                                    alt="Flag of India" /> -->
                                <span class="country-name">India</span>
                                <span class="dot" v-if="selectedCountry === 'India'">&#8226;</span>
                            </button>

                            <button :class="getCountryButtonClass('UAE')" @click="onCountrySelect('UAE')"
                                class="position-relative btn-dark">
                                <!-- <img src="@/assets/imgs/offices/uae.png" class="img-fluid with-border" alt="Flag of UAE" /> -->
                                <span class="country-name">UAE</span>
                                <span class="dot" v-if="selectedCountry === 'UAE'">&#8226;</span>
                            </button>

                            <button :class="getCountryButtonClass('Kuwait')" @click="onCountrySelect('Kuwait')"
                                class="position-relative btn-dark">
                                <!-- <img src="@/assets/imgs/offices/kuw.png" class="img-fluid with-border"
                                    alt="Flag of Kuwait" /> -->
                                <span class="country-name">Kuwait</span>
                                <span class="dot" v-if="selectedCountry === 'Kuwait'">&#8226;</span>
                            </button>
                        </div>





                    </div>
                </div>

                <!-- new content -->
                <section style="    background-color: rgb(247, 244, 255);">
                    <div class="container p-5 my-2">
                        <div class="row">
                            <div class="col-4" v-for="(office, index) in offices" :key="index">
                                <div class="card mb-2">
                    <div class="card-body fixed-card-height">
                        <h5 class="card-title">{{ office.name }}</h5>
                        <a :href="'mailto:' + office.email" class="card-link">{{ office.email }}</a>
                        <p class="card-text">{{ office.address }}</p>
                        <!-- <div class="mt-5"><button type="button" class="btn btn-primary">Directions</button></div> -->
                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>









                <div class="container p-5"></div>
                </div>

                <!-- map -->
                <div class="container p-2 border" style="border-radius: 10px">
                    <div class="map-column">
                        <iframe
                            src="https://www.google.com/maps/d/embed?mid=1ATg8ov8Tg0bBgBrqUinqfDKY0lDMNg0&ehbc=2E312F"
                            allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" height="400px">
                        </iframe>
                    </div>
                </div>

                <div class="container p-5"></div>
                </div>
            </div>


</template>

<script>
import {
    BCard,
    BBadge,
    BCardTitle,
    BCardText,
    BAvatar,
    BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { IMAGEURL } from "@/config";

export default {
    components: {
        BCard,
        BBadge,
        BButton,
        BAvatar,
        BCardTitle,
        BCardText,
    },
    directives: {
        Ripple,
    },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        offices() {
            return this.allOffices.filter((i) => {
                let searchMatch = true;
                let countryMatch = true;
                if (this.search) {
                    const search = this.search.toLowerCase();
                    searchMatch =
                        i.name.toLowerCase().includes(search) ||
                        i.address.toLowerCase().includes(search) ||
                        i.email.toLowerCase().includes(search);
                }
                if (this.selectedCountry) {
                    countryMatch = this.selectedCountry === i.country;
                }

                return searchMatch && countryMatch;
            });
        },
    },
    data() {
        return {
            trainings: [],
            IMAGEURL,
            selectedCountry: "",
            search: "",
            allOffices: [
                {
                    name: "Bandra, Mumbai",
                    address:
                        "ALIFF OVERSEAS, 203, God’s Gift Tower, Next To Lucky Hotel, S.V. Road, Bandra (West), Mumbai – 400050, India",
                    email: "info@aliff.in",
                    country: "India",
                },
                {
                    name: "Lower Parel, Mumbai",
                    address:
                        "1001, 10th Floor, Marathon ICON, Opp. Peninsula Corporate Park, Off, Ganapatrao Kadam Marg, Lower Parel West, Mumbai, Maharashtra 400013",
                    email: "worli@aliff.in",
                    country: "India",
                },
                {
                    name: "Mira Road, Mumbai",
                    address:
                        "R8, Daffodils, Salasar Garden, Near GCC, Mira-Bhayander Road, Mira Road (E), Thane 401 107",
                    email: "preeti@aliff.in",
                    country: "India",
                },
                {
                    name: "Vadodara, Gujarat",
                    address:
                        "205. A WING, 2nd Floor, Siddharth Excellence, Opp Dmart Store, Vasana Main Road, Vadodara 390007",
                    email: "shabana@aliff.in",
                    country: "India",
                },
                {
                    name: "Pune, Maharshtra",
                    address:
                        "St Crispin's Home, Second floor , Left Wing, Near Nal Stop Chowk, Karve road , Pune-411004",
                    email: "rutvij@aliff.in",
                    country: "India",
                },
                {
                    name: "Raipur, Chhattisgarh",
                    address:
                        "Shop No 62 RDA Complex New Rajendra Nagar Raipur",
                    email: "bishwajit@aliff.in",
                    country: "India",
                },
                {
                    name: "Dubai",
                    address: "Al Falasi Residence, 1304 11B street, Mankhool, Dubai",
                    email: "dubai@aliff.in",
                    country: "UAE",
                },
                {
                    name: "Kuwait",
                    address:
                        "AL-Rehab Complex, Office No. 508, floor-5, Tunis street- Hawally, Kuwait.",
                    email: "hina@aliff.in",
                    country: "Kuwait",
                },
            ],
        };
    },

    methods: {
        getCountryButtonClass(country) {
            console.log({ country, selectedCountry: this.selectedCountry });
            if (country === this.selectedCountry) {
                return "btn btn-primary rounded-pill mr-2 filter-button selected";
            }
            return "btn btn-primary rounded-pill mr-2 filter-button";
        },
        onCountrySelect(country) {
            if (country === this.selectedCountry) {
                this.selectedCountry = "";
            } else {
                this.selectedCountry = country;
            }
        },
    },
    beforeMount() {
        // this.getTrainings();
    },
};
</script>

<style>
   .fixed-card-height {
        height: 250px; /* You can adjust the height as needed */
        overflow: hidden;
    }
.with-border {
    border: 2px solid white;
    /* Adjust the border size and color as needed */
    border-radius: 5px;
    /* Optional: Add rounded corners to the border */
}

.dashboard__heading {
    color: #002884;
    font-weight: bold;
    margin-bottom: 1.2rem;
}

.student-dashboard .card-title {
    color: #000000;
    font-weight: 600;
}

.primary-color {
    color: #00d09c;
}

.min-height {
    min-height: 60vh;
}

.selected {
    /* background-color: #002751; */
    /* Change to your preferred selected button style */
    color: #fff;
    /* Change to your preferred text color for selected button */
}

/* .container {
    display: flex;
    height: 50vh;
    overflow: hidden;
} */

.scrollable {
    height: 100%;
    overflow-y: auto;
}

.map-column {
    height: 600px;
}

iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
}

@media (max-width: 768px) {
    .container {
        flex-direction: column-reverse;
        height: auto;
    }

    .scrollable {
        height: auto;
        overflow-y: visible;
    }

    .map-column {
        width: 100%;
    }
}</style>



// WEBPACK FOOTER //
// src/components/pages/FranchiseLocations.vue